import React, { useState, useEffect } from "react";
import { json, useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

function RegisterEmailDestination() {
  const navigate = useNavigate();
  let [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [notes, setNotes] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openInputSuccess, setOpenInputSuccess] = useState(false);
  const [openInputFail, setOpenInputFail] = useState(false);
  
  const resource = 'operation/register-email-destination';

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  useEffect(() => {
    // Retrieve the token from local storage
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

      const formData = {
        email: email,
        notes: notes     
      };

      try {
        const response = await fetch(
          "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/register-email-destination",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
            },
            body: JSON.stringify(formData),
          }
        );

        const data = await response.json();
        const responseBody = JSON.parse(data.body);
        if (!response.ok) {
          setError(data.message || "Failed to submit form");
          throw new Error(data.message || "Failed to submit form");
        }

        const { message } = responseBody;
        if (message == "success") {
          setOpenConfirm(false)
          setOpenInputSuccess(true)
        } else {
          setOpenConfirm(false)
          setOpenInputFail(true)
        }
      } catch (error) {
        console.error("Submission Error:", error.message);
        setError("Submission Error: " + error.message);
      }
  };

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenInputFail(false)
  };

  const handleConfirmation = async (event) => {
    event.preventDefault();
    setOpenConfirm(true);
  };

  function inputSuccess(){
    navigate("/operation/email-destination-list")
  }

  return (
    <div className="container-order-input">
      <Dialog open={openConfirm}>
          <DialogTitle>{"Are you sure you want to register this email destination?"}</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                      Clicking "Yes" will register this email destination.
                  </DialogContentText>
              </DialogContent>
          <DialogActions>
              <Button onClick={handleClose} color="primary">
                  No
              </Button>
              <Button onClick={handleSubmit} color="primary" autoFocus>
                  Yes
              </Button>
          </DialogActions>
        </Dialog> 
        <Dialog open={openInputSuccess}>
          <DialogTitle>{"Register Email Destination submitted successfully"}</DialogTitle>
          <DialogActions>
            <Button onClick={inputSuccess} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog open={openInputFail}>
        <DialogTitle>{"Register Email Destination submitted failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <h1>Cross Connect Register Email Destination</h1>
      <form onSubmit={handleConfirmation}>
        <div className="order-information-order-input">
          <div className="title-order-input">
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="textbox">
              <label htmlFor="contactEmail">Email</label>
              <input
                type="email"
                placeholder="xxx@xxx.com"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
             <div className="textbox">
              <label htmlFor="notes">Notes</label>
              <input
                type="text"
                placeholder="Notes"
                onChange={(e) => setNotes(e.target.value)}
                required
              />
            </div>
            <div className="radio-button">
              <label>Status</label>
              <div className="radio-button-option">
                <label>
                  <input
                    type="radio"
                    value="ACTIVE"
                    checked="TRUE"
                    disabled
                  />
                  Active
                </label>
              </div>
              <div className="radio-button-option">
                <label>
                  <input
                    type="radio"
                    value="INACTIVE"
                    disabled
                  />
                  Inactive
                </label>
              </div>
            </div>
          </div>
        </div>
        <input
          type="submit"
          className="btn-submit-order-input"
          value="Submit"
        />
      </form>
    </div>
  );
}

export default RegisterEmailDestination;
